import { Filter } from '../../filter';
import type { PhoneNumber } from '../../phone-number';
import { ErrorType, FieldValues } from '../../types';

export class ValidPhoneNumberFilter implements Filter<PhoneNumber> {
    async validate(fieldValue: PhoneNumber, otherFields: FieldValues): Promise<Array<ErrorType>> {
        if (!fieldValue.isValidNumber()) {
            return [
                {
                    code: 'format',
                    expectedFormat: 'This number is not a valid one!',
                },
            ];
        }

        return [];
    }
}
